import { useEffect, useState } from 'react';

import { getInputHtmlSize } from 'shared/lib';

import { StyledPaginationJumper } from './styles';

type Props = {
  handlePressEnter: (e: number) => void;
  jumperValue: string;
};

export function PaginationJumper({ handlePressEnter, jumperValue }: Props) {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(jumperValue);
  }, [jumperValue]);

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (Number(e.target.value) > 0 || e.target.value === '') {
      setValue(e.target.value);
    }
  };

  return (
    <StyledPaginationJumper
      value={value}
      onChange={handleValueChange}
      onPressEnter={(e) => {
        const val = Number((e.target as HTMLInputElement).value);

        if (val > 0) {
          handlePressEnter(val);
        }
      }}
      htmlSize={getInputHtmlSize(value)}
    />
  );
}
